import { useState, FC, FormEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Check, Ruler } from 'lucide-react';
import { ResponsiveModal } from '@/shared/ui/responsive-modal';
import { Button } from '@/shared/ui/base';

interface CreateUnitModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (name: string) => void;
}

export const CreateUnitModal: FC<CreateUnitModalProps> = ({ isOpen, onClose, onCreate }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    
    onCreate(name.trim());
    setName('');
    onClose();
  };

  return (
    <ResponsiveModal
        open={isOpen}
        onOpenChange={(open) => !open && onClose()}
        title={t('units.create_modal.title', 'Новая единица')}
        className="max-w-sm"
    >
      <form onSubmit={handleSubmit} className="space-y-5">
        
        <div className="space-y-1">
          <label className="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase ml-1 flex items-center gap-1">
             <Ruler size={12}/> {t('units.create_form.name_label', 'Название')}
          </label>
          <input 
            autoFocus
            type="text"
            placeholder={t('units.create_form.name_placeholder', 'Например: мешок, смена')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full pl-4 pr-4 py-3 bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl focus:border-blue-500 focus:bg-white dark:focus:bg-slate-800 outline-none font-bold text-slate-700 dark:text-slate-100 transition-all"
          />
          <p className="text-[10px] text-slate-400 dark:text-slate-500 px-1 pt-1">
              {t('units.create_form.hint', 'Новая единица будет рассчитываться вручную (не автоматически).')}
          </p>
        </div>

        <Button
           type="submit"
           disabled={!name.trim()}
           variant="primary"
           className="w-full h-14 font-bold text-lg mt-2"
        >
           <Check size={20}/> {t('common.add', 'Добавить')}
        </Button>

      </form>
    </ResponsiveModal>
  );
};

export default CreateUnitModal;
